// eslint-disable-next-line import/no-unresolved
import p5 from 'p5';

const HEARTBEAT_INTERVAL_MS = 5000;
const ANIMATION_DURATION_MS = 2500;
const SVG_WIDTH = 1205;
const SVG_HEIGHT = 443;
const STROKE_COLOR = [0, 61, 187]; // $blue-02: #003dbb;
const BREAKPOINT = 1200;

class ParagraphTypeContainer {
  // eslint-disable-next-line class-methods-use-this
  setupHeartbeat(container) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('heartbeat-animation-wrapper');
    wrapper.style.cssText = [
      'position: absolute',
      'top: 6%',
      'left: 0',
      'width: 100%',
      'height: 100%',
      'overflow: hidden',
      'pointer-events: none',
      'z-index: -1'
    ].join(';');
    container.style.position = 'relative';
    container.style.isolation = 'isolate';
    container.insertBefore(wrapper, container.firstChild);

    let sketchInstance = null;

    const runAnimation = () => {
      if (sketchInstance) {
        sketchInstance.remove();
        sketchInstance = null;
      }

      const containerWidth = container.offsetWidth;
      const containerHeight = container.offsetHeight;

      const isNarrow = window.innerWidth < BREAKPOINT;
      const effectiveSvgWidth = isNarrow ? SVG_WIDTH / 2 : SVG_WIDTH;
      const scale = containerWidth / effectiveSvgWidth;
      const scaledHeight = SVG_HEIGHT * scale;
      const yOffset = 0;

      const themePath = '/themes/custom/sanarenatheme26/images/pulse.png';

      // Disable p5 Friendly Error System to avoid false REMOVE constant warnings
      // eslint-disable-next-line no-param-reassign
      p5.disableFriendlyErrors = true;

      // eslint-disable-next-line new-cap
      sketchInstance = new p5((sketch) => {
        let svgImg;
        let startTime;
        let done = false;

        sketch.setup = async () => {
          const cnv = sketch.createCanvas(containerWidth, containerHeight);
          cnv.style('position', 'absolute');
          cnv.style('top', '0');
          cnv.style('left', '0');
          cnv.style('pointer-events', 'none');
          cnv.parent(wrapper);
          sketch.clear();
          sketch.noLoop();
          svgImg = await sketch.loadImage(themePath);
          startTime = sketch.millis();
          sketch.loop();
        };

        sketch.draw = () => {
          if (done) return;

          sketch.clear();

          const elapsed = sketch.millis() - startTime;
          const progress = Math.min(elapsed / ANIMATION_DURATION_MS, 1);

          const totalW = containerWidth;
          // Reveal front edge: 0 → totalW over first 50% of animation
          const revealEdge = sketch.map(
            Math.min(progress, 0.5),
            0,
            0.5,
            0,
            totalW
          );
          // Erase front edge: 0 → totalW*1.2 over 30%–100% of animation
          const eraseEdge =
            progress > 0.3
              ? sketch.map(Math.min(progress, 1), 0.3, 1, 0, totalW * 1.2)
              : 0;

          if (revealEdge > 0) {
            const clipLeft = Math.min(eraseEdge, totalW);
            const clipRight = Math.min(revealEdge, totalW);

            if (clipRight > clipLeft) {
              sketch.push();
              sketch.drawingContext.save();
              sketch.drawingContext.beginPath();
              sketch.drawingContext.rect(
                clipLeft,
                0,
                clipRight - clipLeft,
                containerHeight
              );
              sketch.drawingContext.clip();

              if (svgImg) {
                if (isNarrow) {
                  sketch.image(
                    svgImg,
                    0,
                    yOffset,
                    containerWidth,
                    scaledHeight,
                    0,
                    0,
                    svgImg.width / 3,
                    svgImg.height
                  );
                } else {
                  sketch.image(
                    svgImg,
                    0,
                    yOffset,
                    containerWidth,
                    scaledHeight
                  );
                }
                sketch.drawingContext.globalCompositeOperation = 'source-atop';
                sketch.fill(STROKE_COLOR[0], STROKE_COLOR[1], STROKE_COLOR[2]);
                sketch.noStroke();
                sketch.rect(0, 0, containerWidth, containerHeight);
                sketch.drawingContext.globalCompositeOperation = 'source-over';
              }

              sketch.drawingContext.restore();
              sketch.pop();
            }
          }

          if (progress >= 1) {
            done = true;
            sketch.noLoop();
            sketch.clear();
          }
        };
      }, wrapper);
    };

    runAnimation();
    setInterval(runAnimation, HEARTBEAT_INTERVAL_MS);

    let currentIsNarrow = window.innerWidth < BREAKPOINT;
    let resizeTimer = null;

    const handleResize = () => {
      const isNarrow = window.innerWidth < BREAKPOINT;
      if (isNarrow !== currentIsNarrow) {
        currentIsNarrow = isNarrow;
        runAnimation();
      }
    };

    window.addEventListener('resize', () => {
      if (resizeTimer) return;
      resizeTimer = setTimeout(() => {
        resizeTimer = null;
        handleResize();
      }, 200);
    });
  }

  setContainers() {
    const { setupHeartbeat } = this;

    Drupal.behaviors.paragraphTypeContainer = {
      attach(context) {
        const containers = once(
          'paragraph-type-container',
          '.blue-with-heartbeat.paragraph--type--container',
          context
        );

        containers.forEach((container) => {
          setupHeartbeat(container);
        });
      }
    };
  }

  run() {
    this.setContainers();
  }
}

export default ParagraphTypeContainer;
